
import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el                    : false,
        	main                   : null,

            conservMaskProportions : true
       };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'moduleSVGMaskControl';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
        this.$win           =   $(window);
		

        this.init();
    }

    init(){

        this.$svg           = this.getSVGMask();
        this.$container     = this.$el.parents( '.svg-mask-container' );
        this.$content       = this.$el.parents( '.svg-mask-content' );
        this.$imgWrapper    = this.$el.parents( '.img-wrapper' );
        this.orw            = parseInt( this.$svg.attr('data-w') );
        this.orh            = parseInt( this.$svg.attr('data-h') );
        this.is_in_hero     = this.$el.parents( '#escr-hero' );
        this.is_in_item_grid= this.$el.parents( '.item-masked' );

    	this.addEvents( true );
	}

    addEvents( b ){
        this.debounceResize(b);
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
            this.onResize();
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    getSVGMask(){
        let classes = this.$el.attr('class').split(/\s+/),
        i  = classes.length,
        _class;
        while( i-- ){
            _class  = classes[i];
            if ( _class.indexOf( 'svg-mask-' ) !== -1 ){
                return $(  '#' + _class );
            }
        }
    }

    onResize(){

        if ( this.is_in_hero ){

            let aW, aH, orw, orh, maxw,
                conservMaskProportions = true;

            this.$imgWrapper.css({ 'padding-bottom' : 0, 'height' : 0 });


            aW = Math.floor( this.$container.width()    - parseInt(this.$container.css('margin-right')) );
            aH = Math.floor( this.$container.height()   - parseInt(this.$container.css('margin-bottom')) );

            if ( this.options.conservMaskProportions ){

                orw = this.orw;
                orh = this.orh;



                if ( aW*orh/orw > aH ){

                    maxw = aH*orw/orh;
                }
                else{
                    maxw = aW;
                }


                //console.log( 'orw = ' + orw + ', orh = ' + orh + ', aW = ' + aW + ', aH = ' + aH + ', aW*orh/orw = '  + (aW*orh/orw) + ', maxw = ' + maxw );

                // resize the image on available space with SVG mask proportions
                this.$imgWrapper.css({
                    //'padding-bottom': 0,
                    'width'  : maxw,
                    'height' : maxw*orh/orw
                });

            }
            else{

                orw = parseInt( this.$imgWrapper.attr('data-width') );
                orh = parseInt( this.$imgWrapper.attr('data-height') );

                if ( aW*orh/orw > aH ){
                    maxw = aH*orw/orh;
                }
                else{
                    maxw = aW;
                }

                this.$content.width( Math.floor( maxw ) );
                
            }        

        }

        if ( this.is_in_item_grid ){

            let aW, aH, orw, orh, maxw,
                conservMaskProportions = true;

            aW = Math.floor( this.$container.width() );
            aH = Math.floor( this.$container.height() );

            if ( this.options.conservMaskProportions ){

                orw = this.orw;
                orh = this.orh;

                if ( aW*orh/orw > aH ){
                    maxw = aH*orw/orh;
                }
                else{
                    maxw = aW;
                }

                // resize the image on available space with SVG mask proportions
                this.$imgWrapper.css({
                    'padding-bottom': 0,
                    'width'  : maxw,
                    'height' : maxw*orh/orw
                });

            }
            else{
              
            }        

        }


    }

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        this.addEvents( false );
    }

}